// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 3H18V5H13V18C13 20.2091 11.2091 22 9 22C6.79086 22 5 20.2091 5 18C5 15.7909 6.79086 14 9 14C9.72857 14 10.4117 14.1948 11 14.5351V3Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-music-2-filled')
export default class Music2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'music-2-filled',
    }
  }
}
